import { render, staticRenderFns } from "./noResource.vue?vue&type=template&id=dc78dbe0&"
import script from "./noResource.vue?vue&type=script&lang=js&"
export * from "./noResource.vue?vue&type=script&lang=js&"
import style0 from "./noResource.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports